import { FC } from "react";
import { Box, Paper, Typography } from "@mui/material";
import { useVirtualBatteries } from "../../../hooks/useVirtualBatteries";
import BatterySelectorItem from "./BatterySelectorItem";
import { useTranslation } from "react-i18next";
import { useContracts } from "@/components/Contracts/hooks/useContracts";
import { BatteryDistribution } from "@/components/VirtualBattery/types/percentages";

interface BatterySelectorParams {
  excludeBatteryId: number;
  selectedBatteryId?: number;
  onSelected: (batteryDistribution: BatteryDistribution) => void;
}

export const BatterySelector: FC<BatterySelectorParams> = ({
  excludeBatteryId, 
  selectedBatteryId, 
  onSelected 
}) => {
  const { t } = useTranslation();
  const { currentContract } = useContracts("electricity");
  const {getBatteriesDistribution} = useVirtualBatteries();
  
  const batteriesDistribution = getBatteriesDistribution(
    currentContract.name,
    excludeBatteryId
  );

  const renderBateriaVirtualSelector = () => {
    const drawedVirtualBatteryItems = [];
    for (let [batteryId, batteryDistribution] of Object.entries(batteriesDistribution)) {
      drawedVirtualBatteryItems.push(
        <BatterySelectorItem
          key={batteryId}
          batteryDistribution={batteryDistribution}
          onClick={(_selectedBatteryDistribution) => onSelected?.(batteryDistribution)}
          selected={selectedBatteryId == Number(batteryId)}
        />
      );
    }

    return (
      <Box sx={{
        display: "flex",
        flexDirection: "column",
        gap: "0.5rem"
      }}>
       {drawedVirtualBatteryItems}
      </Box>
    );
  };

return (
  <Box>
    <Typography variant="h6">
      {t("common:text.select_battery")}:
    </Typography>
    <Paper
      style={{
        padding: "1rem",
        overflowY: "auto",
        maxHeight: "35vh",
      }}
      variant="outlined"
    >
      {renderBateriaVirtualSelector()}
    </Paper>
  </Box>
);
};

export default BatterySelector;
